import React from 'react';
import Finalcutpro1 from '../assets/img/pageimages/Finalcutpro1.jpeg';
import Finalcutpro2 from '../assets/img/pageimages/Finalcutpro2.jpeg';
import Finalcutpro3 from '../assets/img/pageimages/Finalcutpro3.jpeg';

const Finalcutpro = () => {
  return (
    <>
      <style>{`
        /* Importing Poppins font */
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400&display=swap');
        
        .finalcut-container {
          font-family: 'Poppins', sans-serif;
          padding: 4rem 0;
          margin: auto;
          color: #333;
          background-color: #f9fafb; /* Added background color to the whole page */
          /* Ensures content stays within 80% width */
        }

        .finalcut-header {
          margin-bottom: 30px;
        }

        .finalcut-header h1 {
          color: #7620ff;
          margin-bottom: 10px;
          text-align:center;
          
        }

        .finalcut-header p {
          max-width: 80%;
          margin: auto;
          color: #555;
        }

        .image-row {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
          margin: 40px 0;
           max-width: 80%;
           margin:30px auto;
        }

        .image-row img {
          flex: 1 1 calc(33.333% - 20px);
          max-width: 100%;
          height: auto;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          object-fit: cover;
        }

        @media (max-width: 768px) {
          .image-row img {
            flex: 1 1 100%;
          }
        }

        .section-title {
          margin: 30px 0 20px;
          color: #fdba00;
          text-align:center;
        }

        .section-text {
          color: #444;
          line-height: 1.6;
          max-width: 1000px;
          margin: auto;
          text-align: justify;
        }

        .features-list {
          margin-top: 20px;
          padding-left: 20px;
        }

        .features-list li {
          margin-bottom: 10px;
        }

        .who-section {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-top: 40px;
           max-width: 80%;
           margin:30px auto;
        }

        @media (min-width: 768px) {
          .who-section {
            flex-direction: row;
          }
        }

        .who-box {
          flex: 1;
          background-color: #e0f2fe;
          padding: 25px;
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
          
        }

        .who-box h3 {
          color: #7620ff;
          margin-bottom: 10px;
        }

        .who-box p {
          color: #333;
        }
      `}</style>

      <div className="finalcut-container">
        {/* Header */}
        <header className="finalcut-header">
          <h1 style={{ marginTop: "3rem" }}>Final Cut Pro Features</h1>
          <p>
            Final Cut Pro is a professional-grade, non-linear video editing software developed by Apple,
            known for its powerful editing capabilities, intuitive interface, and seamless integration with other Apple products.
          </p>
        </header>

        {/* Images Section with 3 Images */}
        <div className="image-row">
          <img src={Finalcutpro1} alt="Final Cut Pro Screenshot 1" />
          <img src={Finalcutpro2} alt="Final Cut Pro Screenshot 2" />
          <img src={Finalcutpro3} alt="Final Cut Pro Screenshot 3" />
        </div>

        {/* Key Features Section */}
        <h2 className="section-title">Key Features and Capabilities</h2>
        <ul className="section-text features-list">
          <li><strong>Professional-Level Editing:</strong> Designed for high-quality video creation with advanced tools.</li>
          <li><strong>Intuitive Interface:</strong> User-friendly for beginners while offering depth for professionals.</li>
          <li><strong>Apple Integration:</strong> Works seamlessly with Logic Pro, Compressor, and other Apple tools.</li>
          <li><strong>Advanced Tools:</strong> Includes color correction, motion graphics, audio tools, and more.</li>
          <li><strong>Format Support:</strong> Handles SD, HD, 4K, 8K, ProRes, and ProRes RAW formats.</li>
          <li><strong>360° Video Editing:</strong> Full suite for immersive video production.</li>
          <li><strong>HDR Support:</strong> Edit high dynamic range video with precision.</li>
          <li><strong>Closed Captioning:</strong> Built-in tools for captioning in multiple formats.</li>
          <li><strong>Motion & Compressor:</strong> Create graphics and export professionally with these Apple tools.</li>
          <li><strong>Apple Silicon Optimization:</strong> Blazing fast performance on M1/M2 chips.</li>
          <li><strong>AI-Enhanced:</strong> Auto color conform, smart tone mapping, and more.</li>
          <li><strong>One-Time Purchase:</strong> No subscriptions; 90-day free trial available.</li>
        </ul>

        {/* Who is it for? */}
        <h2 className="section-title">Who is it for?</h2>
        <div className="who-section">
          <div className="who-box">
            <h3>🎬 Professionals</h3>
            <p>
              Ideal for filmmakers, content creators, and editors who need powerful, reliable tools.
            </p>
          </div>
          <div className="who-box">
            <h3>💻 Mac Users</h3>
            <p>
              Exclusively for macOS users — integrates flawlessly into the Apple ecosystem.
            </p>
          </div>
          <div className="who-box">
            <h3>🎓 Aspiring Editors</h3>
            <p>
              Despite its depth, Final Cut Pro is user-friendly enough for beginners to grow into.
            </p>
          </div>
        </div>

        {/* Summary */}
        <h2 className="section-title">Summary</h2>
        <p className="section-text">
          Final Cut Pro is a powerful and versatile video editing software offering professional tools, advanced features, and seamless integration within the Apple ecosystem — all in a one-time purchase package.
        </p>
      </div>
    </>
  );
};

export default Finalcutpro;
